/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState, useRef } from "react"
import types from "prop-types"
import clsx from "clsx"
import SvgSpriteIcon from "shared/SvgSpriteIcon"
import { useOnClickOutside, useTabNavigationWithKeyboard } from "hooks"

// This is used for tabs that contains Formsy components. Formsy fields
// needs to be on the DOM, but hidden to work correctly

const TabContents = ({ activeIndex, tabs }) => (
  tabs.map(({ title, TabContent, props = {} }, index) => (
    <div key={title} className={clsx((index !== activeIndex) && "hidden")}>
      <TabContent {...props} />
    </div>
  )))

const HiddenTabs = ({ className = "", tabs, initialActiveSlug = null }) => {
  const [tabNavOpen, setTabNavOpen] = useState(false)
  const openTabNav = () => setTabNavOpen(true)
  const closeTabNav = () => setTabNavOpen(false)

  const tabNavRef = useRef()
  useOnClickOutside(tabNavRef, closeTabNav)

  const [navIsHorizontal, setNavIsHorizontal] = useState(window.innerWidth >= 1024)

  const {
    activeIndex, activeTab, tabRef, changeActiveTab, handleKeyDown,
  } = useTabNavigationWithKeyboard(tabs, initialActiveSlug)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setNavIsHorizontal(true)
      } else {
        setNavIsHorizontal(false)
      }
    }
    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <>
      <nav className="tab-nav-container" aria-labelledby="tab-navigation">
        <div className="lg:hidden text-sm font-medium text-dark mb-1">
          <span id="tab-navigation">Navigation</span>
        </div>
        <svg className="tab-nav-icon"><use xlinkHref={tabNavOpen ? "#chevron-up" : "#chevron-down"} /></svg>
        <ul
          ref={tabNavRef}
          className={clsx(className, "tab-nav", tabNavOpen && "open")}
          onClick={tabNavOpen ? closeTabNav : openTabNav}
          role={navIsHorizontal ? "tablist" : "menu"}
          aria-orientation={navIsHorizontal ? "horizontal" : "vertical"}
          aria-label="form navigation"
        >
          {
            tabs.map(({ iconName, title }, index) => {
              const isActiveTab = index === activeIndex

              return (
                <li
                  key={title}
                  className={clsx(isActiveTab && "active", "tab-link")}
                  role="presentation"
                >
                  {
                    (iconName) && (
                      <SvgSpriteIcon iconName={iconName} className="mr-2" ariaHidden />
                    )
                  }
                  <button
                    className={clsx(isActiveTab && "active")}
                    aria-label={title}
                    onClick={(e) => changeActiveTab(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    tabIndex={isActiveTab ? 0 : -1}
                    role={navIsHorizontal ? "tab" : "menuitem"}
                    aria-selected={isActiveTab}
                    ref={(el) => {
                      tabRef.current[index] = el
                    }}
                  >
                    {title}
                  </button>
                </li>
              )
            })
          }
        </ul>
        {
          activeTab.additionalControls && (
            <div className="absolute right-4 z-30 lg:p-2.5">
              {activeTab.additionalControls}
            </div>
          )
        }
      </nav>

      <TabContents tabs={tabs} activeIndex={activeIndex} />
    </>
  )
}

HiddenTabs.propTypes = {
  className: types.string,
  tabs: types.arrayOf(types.object).isRequired,
  initialActiveSlug: types.string,
}

export default HiddenTabs
